import "./BodyText.css";
const BodyText = ({ textContent, isRegular, isWhite }) => {
    let styleClass = isRegular ?  "regular-body" : "participant" ;
    styleClass = isWhite? styleClass + " regular-body-white" : styleClass ;  
    return <p className={styleClass}>{textContent}</p>;
};

export default BodyText;
